/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://bvxqmtw2tbeelktspfq4emau2i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-vfyl3e6445dadeuvbu3v5akrim",
    "aws_cloud_logic_custom": [
        {
            "name": "applyapprest",
            "endpoint": "https://vqro1d4f7j.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:00b3eeba-8466-4ab0-aa0b-c2fe967a7751",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_UXEQYa25x",
    "aws_user_pools_web_client_id": "397rd9r9q4a9i7q5k7k44mme1e",
    "oauth": {
        "domain": "engineers-production.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://engineers-app.matildaexp.com/login/callback/",
        "redirectSignOut": "https://engineers-app.matildaexp.com/logout/callback/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "engineer-files193149-production",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
